import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IMembers } from "./routeType";

const { key, getPath } = getApi("members.getAll");

type IExtractedRouteType = IMembers["memberProfileCollectionRetrieve"];

export type IGetAllMembers = IPickCollectionQuery<IExtractedRouteType>;

const getAllMembers: Fetcher<
  IGetAllMembers["response"],
  IGetAllMembers["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetAllMembers = createQuery({
  queryKey: [key],
  fetcher: getAllMembers,
});
